import httpClient from './api/httpClient';

const END_POINT = 'dados-pessoais';
export const getOne = () => httpClient.get (END_POINT + '/');
export const create = (dados) => {
    let dadosForm = {
        raca: dados.raca
    };
    return httpClient.post(END_POINT, dadosForm);
}